import DBObject from "../utils/DBObject";
import CloneContext from "../utils/CloneContext";

export default class D3EFeaturebundlesRequest extends DBObject {
  private static readonly _OFFSET: number = 0;
  private static readonly _ORDERBY: number = 1;
  private static readonly _PAGESIZE: number = 2;
  public id: number = 0;
  public otherMaster: DBObject;
  private _pageSize: number = 0;
  private _offset: number = 0;
  private _orderBy: string = "";
  public constructor(
    d3eParams?: Partial<{ offset: number; orderBy: string; pageSize: number }>
  ) {
    super();

    this.setOffset(d3eParams?.offset ?? 0);

    this.setOrderBy(d3eParams?.orderBy ?? "");

    this.setPageSize(d3eParams?.pageSize ?? 0);
  }
  public get d3eType(): string {
    return "D3EFeaturebundlesRequest";
  }
  public clear(): void {
    this.d3eChanges.clear();
  }
  public get isTransientModel(): boolean {
    return;
  }
  public get pageSize(): number {
    return this._pageSize;
  }
  public setPageSize(val: number): void {
    let isValChanged: boolean = this._pageSize !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(D3EFeaturebundlesRequest._PAGESIZE, this._pageSize);

    this._pageSize = val;

    this.fire("pageSize", this);
  }
  public get offset(): number {
    return this._offset;
  }
  public setOffset(val: number): void {
    let isValChanged: boolean = this._offset !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(D3EFeaturebundlesRequest._OFFSET, this._offset);

    this._offset = val;

    this.fire("offset", this);
  }
  public get orderBy(): string {
    return this._orderBy;
  }
  public setOrderBy(val: string): void {
    let isValChanged: boolean = this._orderBy !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(D3EFeaturebundlesRequest._ORDERBY, this._orderBy);

    this._orderBy = val;

    this.fire("orderBy", this);
  }
  public get(field: number): any {
    switch (field) {
      case D3EFeaturebundlesRequest._PAGESIZE: {
        return this._pageSize;
      }

      case D3EFeaturebundlesRequest._OFFSET: {
        return this._offset;
      }

      case D3EFeaturebundlesRequest._ORDERBY: {
        return this._orderBy;
      }
      default: {
        return null;
      }
    }
  }
  public updateD3EChanges(index: number, value: any): void {
    if (this.lockedChanges()) {
      return;
    }

    super.updateD3EChanges(index, value);
  }
  public restore(): void {
    /*
TODO: Might be removed
*/

    this.d3eChanges.restore(this);
  }
  public deepClone(clearId = true): D3EFeaturebundlesRequest {
    let ctx: CloneContext = new CloneContext({ "clearId": clearId });

    return ctx.startClone(this);
  }
  public collectChildValues(ctx: CloneContext): void {}
  public deepCloneIntoObj(dbObj: DBObject, ctx: CloneContext): void {
    let obj: D3EFeaturebundlesRequest = dbObj as D3EFeaturebundlesRequest;

    obj.id = this.id;

    obj.setPageSize(this._pageSize);

    obj.setOffset(this._offset);

    obj.setOrderBy(this._orderBy);
  }
  public set(field: number, value: any): void {
    switch (field) {
      case D3EFeaturebundlesRequest._PAGESIZE: {
        this.setPageSize(value as number);
        break;
      }

      case D3EFeaturebundlesRequest._OFFSET: {
        this.setOffset(value as number);
        break;
      }

      case D3EFeaturebundlesRequest._ORDERBY: {
        this.setOrderBy(value as string);
        break;
      }
    }
  }
}
